export default "__VITE_ASSET__239b91ba__"